import { API, API_BASE } from '../config/api';
import { toFullUrl } from '../config/api';
import { useState, useEffect, useRef, lazy, Suspense } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../context/AuthContext';
import { MerchTab } from '../components/admin/MerchTab';
import { BeatsTab } from '../components/admin/BeatsTab';
import { SiteTab } from '../components/admin/SiteTab';
import { VideosTab } from '../components/admin/VideosTab';
import { MockupCreator } from '../components/admin/MockupCreator';
import { FreeMediaTab } from '../components/admin/FreeMediaTab';
// ArtworkStudio removed
import { SalesDashboard } from '../components/admin/SalesDashboard';
import { FeaturedArtists } from '../components/admin/FeaturedArtists';
import { MixtapesTab } from '../components/admin/MixtapesTab';
import { BulkAlbumDialog } from '../components/admin/BulkAlbumDialog';
import { RafflesTab } from '../components/admin/RafflesTab';
import ThemeTab from '../components/admin/ThemeTab';
import CustomizePanel from '../components/admin/CustomizePanel';
import TeamPanel from '../components/admin/TeamPanel';

// Lazy-load heavy studio components for faster initial load
const MasteringStation = lazy(() => import('../components/admin/MasteringStation'));
const BeatStation = lazy(() => import('../components/admin/BeatStation'));
const ArtworkStudio = lazy(() => import('../components/admin/ArtworkStudio'));
const AnimationStudio = lazy(() => import('../components/admin/AnimationStudio'));
import { PromoGenerator } from '../components/admin/PromoGenerator';
import { SubscribersPanel } from '../components/admin/SubscribersPanel';
import { DiscountsPanel } from '../components/admin/DiscountsPanel';
import { DonationsPanel } from '../components/admin/DonationsPanel';
import { PublishingPanel } from '../components/admin/PublishingPanel';
import { AlbumsPanel } from '../components/admin/AlbumsPanel';
import { TracksPanel } from '../components/admin/TracksPanel';
import { AnalyticsPanel } from '../components/admin/AnalyticsPanel';
import { ScheduledPanel } from '../components/admin/ScheduledPanel';
import { ApplicationsPanel } from '../components/admin/ApplicationsPanel';
import { FeaturedAnalyticsPanel } from '../components/admin/FeaturedAnalyticsPanel';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Switch } from '../components/ui/switch';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../components/ui/dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../components/ui/popover';
import { toast } from 'sonner';
import {
  BarChart3,
  Music,
  Users,
  DollarSign,
  Plus,
  MoreVertical,
  Edit,
  Trash2,
  LogOut,
  Play,
  Download,
  Eye,
  Home,
  Bell,
  Calendar,
  Upload,
  Image as ImageIcon,
  Gift,
  FileAudio,
  Send,
  Loader2,
  Disc,
  Tag,
  Percent,
  User,
  Globe,
  Smartphone,
  Clock,
  FileText,
  Settings,
  ShoppingBag,
  Headphones,
  Lock,
  Video,
  Paintbrush,
  MessageSquare,
  CreditCard,
  Mail,
  Wand2,
  Star,
  Heart,
  Palette,
  Disc3,
  AudioLines,
  Clapperboard,
  Menu,
  Inbox,
  Wallet,
  ArrowUp,
  ArrowDown,
  X as XIcon
} from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar } from 'recharts';


const COLORS = ['#FF3B30', '#22C55E', '#3B82F6', '#F59E0B', '#8B5CF6', '#EC4899'];

export default function Admin() {
  const { user, logout, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('analytics');
  const mountedTabs = useRef(new Set());
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const switchTab = (tab) => {
    setActiveTab(tab);
    setSidebarOpen(false);
  };
  const [tracks, setTracks] = useState([]);
  const [subscribers, setSubscribers] = useState([]);
  const [analytics, setAnalytics] = useState(null);
  const [advancedAnalytics, setAdvancedAnalytics] = useState(null);
  const [albums, setAlbums] = useState([]);
  const [discountCodes, setDiscountCodes] = useState([]);
  const [artistProfile, setArtistProfile] = useState(null);
  const [scheduledReleases, setScheduledReleases] = useState([]);
  const [merch, setMerch] = useState([]);
  const [beats, setBeats] = useState([]);
  const [videos, setVideos] = useState([]);
  const [freeMedia, setFreeMedia] = useState([]);
  const [donations, setDonations] = useState([]);
  const [donationStats, setDonationStats] = useState({ total_count: 0, total_amount: 0 });
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ current: '', new: '', confirm: '' });
  const [changingPassword, setChangingPassword] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [pendingReceiptSession, setPendingReceiptSession] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifOpen, setNotifOpen] = useState(false);
  const [siteSettings, setSiteSettings] = useState({ hero_image: '', site_name: 'MELODROP', tagline: '', marquee_text: '', hero_heading: '', hero_subheading: '', hero_description: '' });
  const [publishingBanner, setPublishingBanner] = useState('');
  const [pendingAppCount, setPendingAppCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [profileFormData, setProfileFormData] = useState({
    stage_name: '',
    legal_name: '',
    bio: '',
    profile_image: '',
    pro: '',
    ipi_number: '',
    isni: '',
    publisher_name: '',
    publisher_ipi: '',
    social_links: {}
  });

  // Track which tabs have been mounted (for display:none persistence)
  useEffect(() => {
    if (['beat-station', 'animation', 'mastering', 'artwork-studio', 'customize', 'theme', 'site'].includes(activeTab)) {
      mountedTabs.current.add(activeTab);
    }
  }, [activeTab]);

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/login');
    } else if (user) {
      // Collaborators can only access their permitted features
      if (user.role === 'collaborator' || user.user?.role === 'collaborator') {
        const perms = user.permissions || user.user?.permissions || [];
        if (perms.length > 0 && !perms.includes(activeTab)) {
          setActiveTab(perms[0]);
        }
      }
      fetchData();
      fetchNotifications();
      // Poll notifications every 30s
      const interval = setInterval(fetchNotifications, 30000);
      return () => clearInterval(interval);
    }
  }, [user, authLoading, navigate]);

  // Permission check — admin sees everything, collaborators see only their permissions
  const isAdmin = user?.role === 'admin' || user?.user?.role === 'admin';
  const userPerms = user?.permissions || user?.user?.permissions || [];
  const canAccess = (tabId) => {
    if (isAdmin) return true;
    return userPerms.includes(tabId);
  };

  // ─── Sidebar tab definitions (data-driven for reorderability) ────────────
  // Default order positions: Featured Stats right after Featured, Wallets REMOVED
  // (Wallets are now embedded inside the Featured Stats panel).
  const ALL_TABS = [
    { id: 'analytics', label: 'Analytics', icon: <BarChart3 className="w-5 h-5" />, perm: 'analytics' },
    { id: 'tracks', label: 'Tracks', icon: <Music className="w-5 h-5" />, perm: 'tracks' },
    { id: 'subscribers', label: 'Subscribers', icon: <Users className="w-5 h-5" />, perm: 'subscribers' },
    { id: 'albums', label: 'Albums', icon: <Disc className="w-5 h-5" />, perm: 'albums' },
    { id: 'raffles', label: 'Raffles', icon: <Gift className="w-5 h-5" />, perm: 'albums' },
    { id: 'mixtapes', label: 'Mixtapes', icon: <Disc className="w-5 h-5" />, perm: 'albums' },
    { id: 'discounts', label: 'Discounts', icon: <Tag className="w-5 h-5" />, perm: 'discounts' },
    { id: 'publishing', label: 'Publishing', icon: <FileText className="w-5 h-5" />, perm: 'publishing' },
    { id: 'scheduled', label: 'Scheduled', icon: <Clock className="w-5 h-5" />, perm: 'scheduled' },
    { id: 'site', label: 'Site', icon: <Settings className="w-5 h-5" />, perm: 'site' },
    { id: 'merch', label: 'Merch', icon: <ShoppingBag className="w-5 h-5" />, perm: 'merch' },
    { id: 'beats', label: 'Beats', icon: <Headphones className="w-5 h-5" />, perm: 'beats' },
    { id: 'free-media', label: 'Free Media', icon: <Music className="w-5 h-5" />, perm: 'free-media' },
    { id: 'videos', label: 'Videos', icon: <Video className="w-5 h-5" />, perm: 'videos' },
    { id: 'mockups', label: 'Mockups', icon: <Paintbrush className="w-5 h-5" />, perm: 'mockups' },
    { id: 'promos', label: 'Promos', icon: <Tag className="w-5 h-5" />, perm: 'promos' },
    { id: 'featured', label: 'Featured', icon: <Star className="w-5 h-5" />, perm: 'featured' },
    { id: 'featured-analytics', label: 'Featured Stats', icon: <BarChart3 className="w-5 h-5" />, perm: 'featured' },
    { id: 'applications', label: 'Applications', icon: <Inbox className="w-5 h-5" />, perm: 'featured',
      badge: pendingAppCount > 0 ? (
        <span className="ml-auto bg-[#DAA520] text-black text-[9px] font-black px-1.5 py-0.5 rounded-sm" data-testid="pending-apps-badge">{pendingAppCount}</span>
      ) : null },
    { id: 'donations', label: 'Donations', icon: <Heart className="w-5 h-5" />, perm: 'donations' },
    { id: 'theme', label: 'Theme', icon: <Palette className="w-5 h-5" />, perm: 'theme' },
    { id: 'customize', label: 'Customize', icon: <Paintbrush className="w-5 h-5" />, perm: 'customize' },
    { id: 'beat-station', label: 'Beat Station', icon: <AudioLines className="w-5 h-5" />, perm: 'beat-station' },
    { id: 'artwork-studio', label: 'Artwork Studio', icon: <Paintbrush className="w-5 h-5" />, perm: 'artwork-studio' },
    { id: 'animation', label: 'Animation', icon: <Clapperboard className="w-5 h-5" />, perm: 'animation' },
    { id: 'mastering', label: 'Mastering', icon: <Disc3 className="w-5 h-5" />, perm: 'mastering' },
    { id: 'team', label: 'Team', icon: <Users className="w-5 h-5" />, perm: '__admin__' },
    { id: 'sales', label: 'Sales', icon: <DollarSign className="w-5 h-5" />, perm: '__admin__' },
  ];

  const DEFAULT_TAB_ORDER = ALL_TABS.map(t => t.id);
  const [tabOrder, setTabOrder] = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem('admin_tab_order') || 'null');
      if (Array.isArray(stored) && stored.length > 0) {
        return [...stored, ...DEFAULT_TAB_ORDER.filter(id => !stored.includes(id))];
      }
    } catch { /* ignore */ }
    return DEFAULT_TAB_ORDER;
  });
  const [editOrderMode, setEditOrderMode] = useState(false);

  // Resolve tabs in saved order + filter by permission (any new tabs not in saved order go to the end)
  const orderedTabs = [
    ...tabOrder.map(id => ALL_TABS.find(t => t.id === id)).filter(Boolean),
    ...ALL_TABS.filter(t => !tabOrder.includes(t.id)),
  ].map(t => ({
    ...t,
    allowed: t.perm === '__admin__' ? isAdmin : canAccess(t.perm),
  }));

  const fetchNotifications = async () => {
    try {
      const { data } = await api.get(`${API}/notifications`, { withCredentials: true });
      setNotifications(data.notifications || []);
      setUnreadCount(data.unread || 0);
    } catch (e) {
      // silently fail
    }
  };

  const markNotificationsRead = async () => {
    try {
      await api.post(`${API}/notifications/read`, {}, { withCredentials: true });
      setUnreadCount(0);
    } catch (e) {
      // silently fail
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const [tracksRes, subscribersRes, analyticsRes, albumsRes, discountsRes, profileRes, advancedRes, scheduledRes, siteRes, merchRes, beatsRes, videosRes, freeMediaRes] = await Promise.all([
        api.get(`${API}/tracks`, { withCredentials: true }),
        api.get(`${API}/subscribers`, { withCredentials: true }),
        api.get(`${API}/analytics`, { withCredentials: true }),
        api.get(`${API}/albums`, { withCredentials: true }),
        api.get(`${API}/discounts`, { withCredentials: true }),
        api.get(`${API}/artist-profile`, { withCredentials: true }).catch(() => ({ data: null })),
        api.get(`${API}/analytics/advanced`, { withCredentials: true }).catch(() => ({ data: null })),
        api.get(`${API}/releases/scheduled`, { withCredentials: true }).catch(() => ({ data: [] })),
        api.get(`${API}/site-settings`).catch(() => ({ data: { hero_image: '', site_name: 'MELODROP', tagline: '', marquee_text: '', hero_heading: '', hero_subheading: '', hero_description: '' } })),
        api.get(`${API}/merch`).catch(() => ({ data: [] })),
        api.get(`${API}/beats`).catch(() => ({ data: [] })),
        api.get(`${API}/videos`).catch(() => ({ data: [] })),
        api.get(`${API}/free-media`).catch(() => ({ data: [] }))
      ]);
      setTracks(tracksRes.data);
      setSubscribers(subscribersRes.data);
      setAnalytics(analyticsRes.data);
      setAlbums(albumsRes.data);
      setDiscountCodes(discountsRes.data);
      setArtistProfile(profileRes.data);
      setAdvancedAnalytics(advancedRes.data);
      setScheduledReleases(scheduledRes.data);
      if (siteRes.data) setSiteSettings(siteRes.data);
      if (siteRes.data?.publishing_banner) setPublishingBanner(siteRes.data.publishing_banner);
      setMerch(merchRes.data);
      setBeats(beatsRes.data);
      setVideos(videosRes.data);
      setFreeMedia(freeMediaRes.data);

      // Fetch donations separately (not critical if it fails)
      try {
        const [donationsRes, donationStatsRes] = await Promise.all([
          api.get(`${API}/donations`, { withCredentials: true }),
          api.get(`${API}/donations/stats`, { withCredentials: true })
        ]);
        setDonations(donationsRes.data);
        setDonationStats(donationStatsRes.data);
      } catch { /* ignore */ }

      // Fetch pending applications count (low-priority)
      try {
        const pendingAppsRes = await api.get(`${API}/featured-artists/admin/applications`, { params: { status: 'pending' } });
        setPendingAppCount(pendingAppsRes.data.length);
      } catch { /* ignore */ }
      
      // Pre-fill profile form if exists
      if (profileRes.data) {
        setProfileFormData(profileRes.data);
      }
    } catch (e) {
      console.error('Failed to fetch data', e);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };


  // Site image upload handlers are now in SiteTab component

  // Scheduled release handlers
  if (authLoading || loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#FF3B30] border-t-transparent animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="admin-dashboard">
      {/* Header */}
      <header className="border-b border-[#262626] px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/">
              <span className="font-cabinet text-xl font-black uppercase tracking-tighter text-[#FF3B30]">
                MELODROP
              </span>
            </Link>
            <span className="text-[#A3A3A3]">/</span>
            <span className="overline">ADMIN</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-[#A3A3A3] hover:text-white transition-colors">
              <Home className="w-5 h-5" />
            </Link>
            <span className="text-[#A3A3A3]">{user?.email}</span>
            <Popover open={notifOpen} onOpenChange={(open) => {
              setNotifOpen(open);
              if (open && unreadCount > 0) markNotificationsRead();
            }}>
              <PopoverTrigger asChild>
                <Button
                  variant="outline"
                  className="rounded-none border-[#262626] hover:border-[#FF3B30] relative"
                  data-testid="notifications-btn"
                >
                  <Bell className="w-4 h-4" />
                  {unreadCount > 0 && (
                    <span className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-[#FF3B30] text-white text-[10px] font-bold flex items-center justify-center" data-testid="notif-unread-badge">
                      {unreadCount > 9 ? '9+' : unreadCount}
                    </span>
                  )}
                </Button>
              </PopoverTrigger>
              <PopoverContent align="end" className="w-96 p-0 bg-[#141414] border-[#262626] rounded-none max-h-[480px] overflow-hidden" data-testid="notifications-panel">
                <div className="px-4 py-3 border-b border-[#262626] flex items-center justify-between">
                  <h3 className="font-cabinet font-bold uppercase text-sm tracking-wider">Notifications</h3>
                  {notifications.length > 0 && (
                    <span className="text-xs text-[#A3A3A3]">{notifications.length} recent</span>
                  )}
                </div>
                <div className="overflow-y-auto max-h-[400px]">
                  {notifications.length === 0 ? (
                    <div className="p-8 text-center">
                      <Bell className="w-8 h-8 mx-auto text-[#262626] mb-2" />
                      <p className="text-[#A3A3A3] text-sm">No notifications yet</p>
                    </div>
                  ) : (
                    notifications.map((n, i) => {
                      const icon = n.type === 'comment' ? <MessageSquare className="w-4 h-4 text-[#3B82F6]" /> :
                                   n.type === 'subscriber' ? <Mail className="w-4 h-4 text-[#22C55E]" /> :
                                   n.type === 'presave' ? <Bell className="w-4 h-4 text-[#F59E0B]" /> :
                                   n.type === 'order' ? <CreditCard className="w-4 h-4 text-[#FF3B30]" /> :
                                   <Bell className="w-4 h-4 text-[#A3A3A3]" />;
                      const timeAgo = n.created_at ? (() => {
                        const diff = Date.now() - new Date(n.created_at).getTime();
                        const mins = Math.floor(diff / 60000);
                        if (mins < 1) return 'just now';
                        if (mins < 60) return `${mins}m ago`;
                        const hrs = Math.floor(mins / 60);
                        if (hrs < 24) return `${hrs}h ago`;
                        const days = Math.floor(hrs / 24);
                        return `${days}d ago`;
                      })() : '';
                      return (
                        <button
                          key={`${n.id}-${i}`}
                          onClick={() => {
                            if (n.type === 'order' && n.id) {
                              setPendingReceiptSession(n.id);
                              setActiveTab('sales');
                            } else if (n.tab) {
                              setActiveTab(n.tab);
                            }
                            setNotifOpen(false);
                          }}
                          className="w-full px-4 py-3 flex items-start gap-3 hover:bg-[#1A1A1A] transition-colors text-left border-b border-[#1A1A1A] last:border-0"
                          data-testid={`notif-item-${i}`}
                        >
                          <div className="mt-0.5 flex-shrink-0">{icon}</div>
                          <div className="flex-1 min-w-0">
                            <p className="text-sm text-white truncate">{n.title}</p>
                            {n.detail && <p className="text-xs text-[#A3A3A3] truncate mt-0.5">{n.detail}</p>}
                          </div>
                          <span className="text-[10px] text-[#666] flex-shrink-0 mt-0.5">{timeAgo}</span>
                        </button>
                      );
                    })
                  )}
                </div>
              </PopoverContent>
            </Popover>
            <Button
              onClick={() => setActiveTab('site')}
              variant="outline"
              className="rounded-none border-[#262626] hover:border-[#FF3B30]"
              data-testid="header-site-settings-btn"
            >
              <Settings className="w-4 h-4" />
            </Button>
            <Button
              onClick={() => setChangePasswordOpen(true)}
              variant="outline"
              className="rounded-none border-[#262626] hover:border-[#FF3B30]"
              data-testid="change-password-btn"
            >
              <Lock className="w-4 h-4" />
            </Button>
            <Button
              onClick={handleLogout}
              variant="outline"
              className="rounded-none border-[#262626] hover:border-[#FF3B30]"
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </header>

      {/* Change Password Dialog */}
      <Dialog open={changePasswordOpen} onOpenChange={(open) => { setChangePasswordOpen(open); if (!open) setPasswordForm({ current: '', new: '', confirm: '' }); }}>
        <DialogContent className="bg-[#141414] border-[#262626] rounded-none max-w-md">
          <DialogHeader>
            <DialogTitle className="font-cabinet text-xl font-black uppercase">CHANGE PASSWORD</DialogTitle>
          </DialogHeader>
          <form onSubmit={async (e) => {
            e.preventDefault();
            if (passwordForm.new !== passwordForm.confirm) {
              toast.error('New passwords do not match');
              return;
            }
            if (passwordForm.new.length < 6) {
              toast.error('Password must be at least 6 characters');
              return;
            }
            setChangingPassword(true);
            try {
              await api.post(`${API}/auth/change-password`, {
                current_password: passwordForm.current,
                new_password: passwordForm.new
              });
              toast.success('Password changed successfully!');
              setChangePasswordOpen(false);
              setPasswordForm({ current: '', new: '', confirm: '' });
            } catch (err) {
              { const detail = err.response?.data?.detail; toast.error(typeof detail === 'string' ? detail : 'Failed to change password'); }
            } finally {
              setChangingPassword(false);
            }
          }} className="space-y-4 mt-4">
            <div>
              <Label className="overline">Current Password</Label>
              <Input type="password" value={passwordForm.current}
                onChange={(e) => setPasswordForm(prev => ({ ...prev, current: e.target.value }))}
                className="mt-2 bg-[#0A0A0A] border-[#262626] rounded-none" required
                data-testid="current-password-input" />
            </div>
            <div>
              <Label className="overline">New Password</Label>
              <Input type="password" value={passwordForm.new}
                onChange={(e) => setPasswordForm(prev => ({ ...prev, new: e.target.value }))}
                className="mt-2 bg-[#0A0A0A] border-[#262626] rounded-none" required
                data-testid="new-password-input" />
            </div>
            <div>
              <Label className="overline">Confirm New Password</Label>
              <Input type="password" value={passwordForm.confirm}
                onChange={(e) => setPasswordForm(prev => ({ ...prev, confirm: e.target.value }))}
                className="mt-2 bg-[#0A0A0A] border-[#262626] rounded-none" required
                data-testid="confirm-password-input" />
            </div>
            <Button type="submit" disabled={changingPassword}
              className="w-full bg-[#FF3B30] hover:bg-white hover:text-[#0A0A0A] rounded-none" data-testid="submit-change-password">
              {changingPassword ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Changing...</> : 'CHANGE PASSWORD'}
            </Button>
          </form>
        </DialogContent>
      </Dialog>

      <div className="flex relative">
        {/* Mobile sidebar toggle */}
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="lg:hidden fixed top-[72px] left-2 z-50 w-10 h-10 flex items-center justify-center bg-[#FF3B30] text-white rounded-lg shadow-lg"
          data-testid="sidebar-toggle"
        >
          {sidebarOpen ? <XIcon className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>

        {/* Sidebar overlay for mobile */}
        {sidebarOpen && (
          <div className="lg:hidden fixed inset-0 bg-black/60 z-30" onClick={() => setSidebarOpen(false)} />
        )}

        {/* Sidebar */}
        <aside className={`
          fixed lg:sticky top-0 lg:top-0 z-40 lg:z-auto
          w-56 lg:w-52 border-r border-[#262626] bg-[#0A0A0A]
          min-h-[calc(100vh-65px)] max-h-[calc(100vh-65px)] overflow-y-auto
          transition-transform duration-200
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}>
          <nav className="py-4 pt-2">
            {/* Edit Order toggle */}
            <div className="px-3 pb-2 border-b border-[#262626] mb-2 flex items-center justify-between">
              <span className="text-[9px] uppercase tracking-[0.2em] text-[#666] font-bold">{editOrderMode ? 'EDITING ORDER' : 'TABS'}</span>
              <button
                onClick={() => setEditOrderMode(!editOrderMode)}
                className={`text-[9px] uppercase tracking-wider font-bold px-2 py-1 border transition-colors ${editOrderMode ? 'bg-[#DAA520] border-[#DAA520] text-black' : 'border-[#262626] text-[#A3A3A3] hover:border-[#DAA520] hover:text-[#DAA520]'}`}
                data-testid="toggle-tab-order"
                title="Drag-to-reorder admin tabs"
              >
                {editOrderMode ? 'DONE' : 'EDIT ORDER'}
              </button>
            </div>
            {orderedTabs.map((t, idx) => {
              if (!t.allowed) return null;
              const isActive = activeTab === t.id;
              const moveTab = (dir) => {
                const ids = orderedTabs.filter(x => x.allowed).map(x => x.id);
                const i = ids.indexOf(t.id);
                const target = i + dir;
                if (target < 0 || target >= ids.length) return;
                const newOrder = [...ids];
                [newOrder[i], newOrder[target]] = [newOrder[target], newOrder[i]];
                setTabOrder(newOrder);
                try { localStorage.setItem('admin_tab_order', JSON.stringify(newOrder)); } catch { /* ignore quota errors */ }
              };
              return (
                <div key={t.id} className="flex items-center group" data-testid={`tab-row-${t.id}`}>
                  <button
                    onClick={() => !editOrderMode && switchTab(t.id)}
                    className={`sidebar-link flex-1 ${isActive ? 'active' : ''} ${editOrderMode ? 'cursor-default opacity-70' : ''}`}
                    data-testid={`tab-${t.id}`}
                    disabled={editOrderMode}
                  >
                    {t.icon}
                    {t.label}
                    {t.badge}
                  </button>
                  {editOrderMode && (
                    <div className="flex flex-col gap-0.5 pr-1.5">
                      <button onClick={() => moveTab(-1)} disabled={idx === 0}
                        className={`w-5 h-4 flex items-center justify-center ${idx === 0 ? 'text-[#333] cursor-not-allowed' : 'text-[#A3A3A3] hover:text-[#DAA520]'}`}
                        data-testid={`tab-up-${t.id}`}>
                        <ArrowUp className="w-3 h-3" />
                      </button>
                      <button onClick={() => moveTab(1)} disabled={idx === orderedTabs.length - 1}
                        className={`w-5 h-4 flex items-center justify-center ${idx === orderedTabs.length - 1 ? 'text-[#333] cursor-not-allowed' : 'text-[#A3A3A3] hover:text-[#DAA520]'}`}
                        data-testid={`tab-down-${t.id}`}>
                        <ArrowDown className="w-3 h-3" />
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-3 sm:p-4 lg:p-6 pb-24 pl-12 lg:pl-6 min-w-0 overflow-x-hidden ml-0 lg:ml-0">
          {/* Analytics Tab */}
          {activeTab === 'analytics' && analytics && (
            <AnalyticsPanel analytics={analytics} />
          )}

          {/* Tracks Tab */}
          {activeTab === 'tracks' && (
            <TracksPanel tracks={tracks} setTracks={setTracks} albums={albums} onRefresh={fetchData} />
          )}

          {/* Subscribers Tab */}
          {activeTab === 'subscribers' && (
            <SubscribersPanel subscribers={subscribers} setSubscribers={setSubscribers} />
          )}

          {/* Raffles Tab */}
          {activeTab === 'raffles' && (
            <RafflesTab />
          )}

          {/* Mixtapes Tab */}
          {activeTab === 'mixtapes' && (
            <MixtapesTab />
          )}

          {/* Albums Tab */}
          {activeTab === 'albums' && (
            <AlbumsPanel albums={albums} setAlbums={setAlbums} onRefresh={fetchData} />
          )}

          {/* Discounts Tab */}
          {activeTab === 'discounts' && (
            <DiscountsPanel discountCodes={discountCodes} onRefresh={fetchData} />
          )}

          {activeTab === 'publishing' && (
            <PublishingPanel
              publishingBanner={publishingBanner}
              setPublishingBanner={setPublishingBanner}
              artistProfile={artistProfile}
              advancedAnalytics={advancedAnalytics}
              profileFormData={profileFormData}
              setProfileFormData={setProfileFormData}
              onProfileSaved={fetchData}
            />
          )}

          {activeTab === 'scheduled' && (
            <ScheduledPanel scheduledReleases={scheduledReleases} onRefresh={fetchData} />
          )}

          {/* Site Tab */}
          {(activeTab === 'site' || mountedTabs.current.has('site')) && (
          <div style={{ display: activeTab === 'site' ? 'block' : 'none' }}>
            <SiteTab
              siteSettings={siteSettings}
              setSiteSettings={setSiteSettings}
              profileFormData={profileFormData}
              setProfileFormData={setProfileFormData}
            />
          </div>
          )}

          {activeTab === 'merch' && (
            <MerchTab merch={merch} onRefresh={fetchData} />
          )}

          {activeTab === 'beats' && (
            <BeatsTab beats={beats} onRefresh={fetchData} />
          )}

          {activeTab === 'free-media' && (
            <FreeMediaTab freeMedia={freeMedia} onRefresh={fetchData} />
          )}

          {activeTab === 'videos' && (
            <VideosTab videos={videos} onRefresh={fetchData} />
          )}
          {activeTab === 'mockups' && (
            <div className="space-y-6" data-testid="mockups-content">
              <h2 className="font-cabinet text-2xl font-black uppercase tracking-tighter">
                MERCH MOCKUP CREATOR
              </h2>
              <p className="text-[#A3A3A3]">Design product mockups by uploading your artwork onto blank templates. Save as draft or publish directly to your merch store.</p>
              <MockupCreator onMockupSaved={fetchData} />
            </div>
          )}

          {activeTab === 'promos' && (
            <PromoGenerator tracks={tracks} beats={beats} merchItems={merch} onRefresh={fetchData} />
          )}
          {activeTab === 'featured' && (
            <FeaturedArtists />
          )}
          {activeTab === 'applications' && (
            <ApplicationsPanel />
          )}
          {activeTab === 'featured-analytics' && (
            <FeaturedAnalyticsPanel />
          )}
          {activeTab === 'donations' && (
            <DonationsPanel donations={donations} donationStats={donationStats} />
          )}

          {(activeTab === 'theme' || mountedTabs.current.has('theme')) && (
          <div style={{ display: activeTab === 'theme' ? 'block' : 'none' }}>
            <ThemeTab
              siteSettings={siteSettings}
              onSettingsUpdate={(updated) => setSiteSettings(updated)}
            />
          </div>
          )}
          {(activeTab === 'customize' || mountedTabs.current.has('customize')) && (
          <div style={{ display: activeTab === 'customize' ? 'block' : 'none' }}>
            <CustomizePanel
              siteSettings={siteSettings}
              onSettingsUpdate={(updated) => setSiteSettings(updated)}
            />
          </div>
          )}
          {activeTab === 'team' && isAdmin && (
            <TeamPanel />
          )}
          {(activeTab === 'beat-station' || mountedTabs.current.has('beat-station')) && (
          <div style={{ display: activeTab === 'beat-station' ? 'block' : 'none' }}>
            <Suspense fallback={<div className="p-8 text-center text-[#666]">Loading Beat Station...</div>}>
              <BeatStation />
            </Suspense>
          </div>
          )}
          {(activeTab === 'artwork-studio' || mountedTabs.current.has('artwork-studio')) && (
          <div style={{ display: activeTab === 'artwork-studio' ? 'block' : 'none' }}>
            <Suspense fallback={<div className="p-8 text-center text-[#666]">Loading Artwork Studio...</div>}>
              <ArtworkStudio />
            </Suspense>
          </div>
          )}
          {(activeTab === 'animation' || mountedTabs.current.has('animation')) && (
          <div style={{ display: activeTab === 'animation' ? 'block' : 'none' }}>
            <Suspense fallback={<div className="p-8 text-center text-[#666]">Loading Animation Studio...</div>}>
              <AnimationStudio />
            </Suspense>
          </div>
          )}
          {(activeTab === 'mastering' || mountedTabs.current.has('mastering')) && (
          <div style={{ display: activeTab === 'mastering' ? 'block' : 'none' }}>
            <Suspense fallback={<div className="p-8 text-center text-[#666]">Loading Mastering Station...</div>}>
              <MasteringStation />
            </Suspense>
          </div>
          )}
          {activeTab === 'sales' && (
            <div className="space-y-6">
              <h2 className="font-cabinet text-2xl font-black uppercase tracking-tighter">
                SALES DASHBOARD
              </h2>
              <SalesDashboard
                openReceiptSession={pendingReceiptSession}
                onReceiptOpened={() => setPendingReceiptSession(null)}
              />
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
